"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserDevicePlatformCore = exports.calculateDenominationValues = exports.applyDiscount = exports.applyFee = exports.PIGGY_BANKS_MULTIPLIER = exports.convertPlainObjectFieldsToFirestoreTypes = void 0;
const ua_parser_js_1 = require("ua-parser-js");
const types_1 = require("./types");
/**
 * Converts an object in place to have their fields be converted to Firestore types.
 *
 * @param obj The object to convert.
 */
const convertPlainObjectFieldsToFirestoreTypes = (obj) => {
    for (const key in obj) {
        const currVal = obj[key];
        if (currVal instanceof Object) {
            if ('_nanoseconds' in currVal && '_seconds' in currVal) {
                obj[key] = types_1.FTimestampFunc.new(currVal._seconds, currVal._nanoseconds);
            }
            else if ('nanoseconds' in currVal && 'seconds' in currVal) {
                obj[key] = types_1.FTimestampFunc.new(currVal.seconds, currVal.nanoseconds);
            }
            else {
                (0, exports.convertPlainObjectFieldsToFirestoreTypes)(currVal);
            }
            // TODO add support for DocumentRefs
        }
    }
};
exports.convertPlainObjectFieldsToFirestoreTypes = convertPlainObjectFieldsToFirestoreTypes;
// export const convertPlainObjectFieldsToFirebaseAdminTypes = (obj: any) => {
//   for (const key in obj) {
//     const currVal = obj[key];
//     if (currVal instanceof Object) {
//       if ('_nanoseconds' in currVal && '_seconds' in currVal) {
//         obj[key] = new firestore.Timestamp(currVal._seconds, currVal._nanoseconds);
//       } else if ('nanoseconds' in currVal && 'seconds' in currVal) {
//         obj[key] = new firestore.Timestamp(currVal.seconds, currVal.nanoseconds);
//       } else {
//         convertPlainObjectFieldsToFirebaseAdminTypes(currVal);
//       }
//       // TODO add support for DocumentRefs
//     }
//   }
// };
const PIGGY_BANKS_MULTIPLIER = (denomination) => denomination * 100;
exports.PIGGY_BANKS_MULTIPLIER = PIGGY_BANKS_MULTIPLIER;
const applyFee = (value, fee, minValue) => {
    if (fee === undefined || fee === null || isNaN(fee)) {
        return value;
    }
    const feeValue = (value / 100) * fee;
    if (minValue && feeValue < minValue) {
        return value + minValue;
    }
    return value + feeValue;
};
exports.applyFee = applyFee;
const applyDiscount = (value, discount) => discount ? Math.ceil(value * (1 - discount / 100)) : value;
exports.applyDiscount = applyDiscount;
const calculateDenominationValues = (denomination, discount, fee, minFeeValue) => {
    let piggyBanksValue = (0, exports.PIGGY_BANKS_MULTIPLIER)(denomination);
    piggyBanksValue = (0, exports.applyFee)(piggyBanksValue, fee, minFeeValue && (0, exports.PIGGY_BANKS_MULTIPLIER)(minFeeValue));
    piggyBanksValue = (0, exports.applyDiscount)(piggyBanksValue, discount);
    return {
        piggyBanksValue,
    };
};
exports.calculateDenominationValues = calculateDenominationValues;
const getUserDevicePlatformCore = (userAgent) => {
    const { os } = new ua_parser_js_1.UAParser(userAgent).getResult();
    if (os.name === types_1.GamePlatform.Android) {
        return { platform: types_1.GamePlatform.Android, notFound: false };
    }
    else if (os.name === types_1.GamePlatform.iOS) {
        return { platform: types_1.GamePlatform.iOS, notFound: false };
    }
    return { platform: types_1.GamePlatform.Android, notFound: true };
};
exports.getUserDevicePlatformCore = getUserDevicePlatformCore;
